import { render, staticRenderFns } from "./FfTable.vue?vue&type=template&id=c28c5496"
import script from "./FfTable.vue?vue&type=script&lang=ts"
export * from "./FfTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports